/**
 * What a tab does the moment it learns a new version is waiting, on either path that shows the
 * gate: the service worker's onNeedRefresh (main.ts) and the server's 426 stale-client answer
 * (app-update.ts). Kept apart from both so it can be tested without a service worker.
 *
 * The live-update stream is stopped for good BEFORE the gate is shown, not when Reload is clicked
 * (rule 1 of app-update-acceptance.md, @APP-UPDATE-001). A tab showing the gate can use nothing the
 * stream delivers, and an open stream kept Chrome's waiting worker waiting on 2026-09-28: with
 * several 4C tabs open, the new version could not take over until every other tab was closed.
 * Stopping on show means every tab that has seen the gate lets go of the old version, whether or
 * not anyone clicks anything in it.
 */

type ReloadHandler = () => void | Promise<void>;

export interface NewVersionGateDeps {
  /** The live-update client's permanent stop (SSEClient.stopForGood). */
  stopLiveUpdates: () => void;
  /** Shows the blocking gate with its Reload action (UpdateNotifier.show). */
  showGate: (onReload: ReloadHandler) => void;
  /** What Reload does: the bounded apply-and-reload of reload-after-update.ts (D-126). */
  onReload: ReloadHandler;
}

/** Stops the live-update stream, then shows the gate. */
export function openNewVersionGate(deps: NewVersionGateDeps): void {
  deps.stopLiveUpdates();
  deps.showGate(deps.onReload);
}
